import { render, staticRenderFns } from "./WalletPage.vue?vue&type=template&id=10ca0762&scoped=true"
import script from "./WalletPage.vue?vue&type=script&lang=js"
export * from "./WalletPage.vue?vue&type=script&lang=js"
import style0 from "./WalletPage.vue?vue&type=style&index=0&id=10ca0762&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ca0762",
  null
  
)

export default component.exports